import { createFileRoute } from "@tanstack/react-router";
import { AdminBlogTab } from "@/components/admin/AdminBlogTab";

export const Route = createFileRoute("/_authenticated/admin/blog")({
  head: () => ({ meta: [{ title: "Blog — Admin" }] }),
  component: AdminBlogPage,
});

function AdminBlogPage() {
  return <AdminBlogTab />;
}
